import { Chip } from "@aircall/ds";

import { getClosestColor } from "@/helpers/colors/colors.helpers";
import { useLuminance } from "@/hooks/useLuminance/useLuminance";

import { TAG_COLORS, THRESHOLD } from "./TagBeautified.constants";
import { TagBeautifiedProps } from "./TagBeautified.decl";

export function TagBeautified({
  color,
  children,
  "data-test": dataTest = "tag-beautified",
}: TagBeautifiedProps) {
  const { textColor } = useLuminance({
    color,
    threshold: THRESHOLD,
  });

  const { color: backgroundColor } = getClosestColor(color, TAG_COLORS);

  // ds >= 0.21 renders the Chip via Badge, which layers a translucent "film"
  // (`OVERLAY_*`, a `background-image` gradient) on top of the background to
  // produce its tonal variants. That film washes out our solid `backgroundColor`
  // (an inline `background-color` can't override a `background-image`). We drive
  // the color ourselves, so disable the film to keep the pill fully saturated.
  return (
    <Chip
      data-test={dataTest}
      style={{ backgroundColor, backgroundImage: "none", color: textColor }}
    >
      {children}
    </Chip>
  );
}
